import CompleteSectionForm from '@Components/CompleteSectionForm/CompleteSectionForm';
import { enabledGeneralInfoCompletedSection } from '@Router/NatureOfBusiness/completedSectionUtils';
import { useWatch } from 'react-hook-form';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { Role } from 'src/Enum/Report';

const CompletionCheckBox = () => {
  const { isPublished } = useProgressBar();
  const generalInfoThai = useWatch({ name: 'corporateInformation.thai' });
  const generalInfoEnglish = useWatch({ name: 'corporateInformation.english' });
  const introduction = useWatch({ name: 'corporateInformation.introduction' });
  const remark = useWatch({ name: 'corporateInformation.remark' });
  const completedSection = useWatch({
    name: `corporateInformation.completedSection`,
  });
  const { setValue } = useNatureOfBusinessForm();

  const completeGeneralInfoThai = {
    ...generalInfoThai,
    introductionTh: introduction?.descriptionTh,
    remarkTh: remark?.descriptionTh,
  };

  const completeGeneralInfoEnglish = {
    ...generalInfoEnglish,
    introductionEn: introduction?.descriptionEn,
    remarkEn: remark?.descriptionEn,
  };

  return (
    <CompleteSectionForm
      checkSectionName="corporateInformation.completedSection"
      enableCheckSectionTh={
        !isPublished &&
        enabledGeneralInfoCompletedSection(completeGeneralInfoThai)
      }
      enableCheckSectionEn={
        !isPublished &&
        enabledGeneralInfoCompletedSection(completeGeneralInfoEnglish)
      }
      onCompleteThChange={(checked) => {
        if (!checked) {
          setValue('corporateInformation.completedSection', {
            ...completedSection,
            isCompletedTh: false,
            roleStampTh: Role.NONE,
            dateTh: undefined,
          });
        }
      }}
      onCompleteEnChange={(checked) => {
        if (!checked) {
          setValue('corporateInformation.completedSection', {
            ...completedSection,
            isCompletedEn: false,
            roleStampEn: Role.NONE,
            dateEn: undefined,
          });
        }
      }}
    />
  );
};

export default CompletionCheckBox;
